module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "journey-preview"
  }, [(!_vm.hasJourney) ? _c('div', {
    staticClass: "jp-empty"
  }, [_vm._v("\n    No journey loaded yet."), _c('br'), _vm._v("Use the Chat tab to build one, then preview it here.\n  ")]) : [(_vm.availableLanguages.length > 1) ? _c('div', {
    staticClass: "jp-lang-bar"
  }, _vm._l((_vm.availableLanguages), function(lang) {
    return _c('button', {
      key: lang,
      class: ['jp-lang-btn', {
        'jp-lang-btn--active': _vm.selectedLang === lang
      }],
      on: {
        "click": function($event) {
          return _vm.switchLang(lang)
        }
      }
    }, [_vm._v("\n        " + _vm._s(lang) + "\n      ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "messagesContainer",
    staticClass: "jp-messages"
  }, [_vm._l((_vm.messages), function(msg, i) {
    return _c('div', {
      key: i,
      class: ['jp-msg', msg.role]
    }, [_c('div', {
      staticClass: "jp-msg-inner"
    }, [(msg.text) ? _c('div', {
      staticClass: "jp-bubble",
      domProps: {
        "innerHTML": _vm._s(_vm.renderText(msg.text))
      }
    }) : _vm._e(), _vm._v(" "), (msg.hint) ? _c('div', {
      staticClass: "jp-hint"
    }, [_vm._v(_vm._s(msg.hint))]) : _vm._e(), _vm._v(" "), (msg.stageName) ? _c('div', {
      staticClass: "jp-stage-label"
    }, [_vm._v(_vm._s(msg.stageName))]) : _vm._e()])])
  }), _vm._v(" "), (_vm.ended) ? _c('div', {
    staticClass: "jp-ended"
  }, [_vm._v(_vm._s(_vm.endNote || 'Journey complete ✓'))]) : _vm._e(), _vm._v(" "), (_vm.stopReason) ? _c('div', {
    staticClass: "jp-stopped"
  }, [_vm._v(_vm._s(_vm.stopReason))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "jp-actions"
  }, [(!_vm.ended && _vm.pending) ? [(_vm.pending.buttons && _vm.pending.buttons.length) ? _c('div', {
    staticClass: "jp-choice-buttons"
  }, _vm._l((_vm.pending.buttons), function(btn, i) {
    return _c('button', {
      key: i,
      staticClass: "jp-choice-btn",
      on: {
        "click": function($event) {
          return _vm.selectChoice(i)
        }
      }
    }, [_vm._v("\n            " + _vm._s(btn) + "\n          ")])
  }), 0) : (_vm.pending.isTextInput) ? _c('div', {
    staticClass: "jp-text-input-bar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textInputValue),
      expression: "textInputValue"
    }],
    staticClass: "jp-text-input",
    attrs: {
      "placeholder": _vm.pending.inputHint || 'Type your response...'
    },
    domProps: {
      "value": (_vm.textInputValue)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitTextInput.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textInputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "jp-text-submit",
    on: {
      "click": _vm.submitTextInput
    }
  }, [_vm._v("→")])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.messages.length > 0) ? _c('button', {
    staticClass: "jp-restart-btn",
    on: {
      "click": _vm.restart
    }
  }, [_vm._v("\n        ↺ Restart\n      ")]) : _vm._e()], 2)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-57ef819e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/JourneyPreview.vue
// module id = sLKs
// module chunks = 1